/**
 * 管理后台：轨迹数据管理
 */
import { useState } from 'react';
import { message } from '../utils/antdMessage';
import { confirmDangerousAction } from '../pages/admin/dangerConfirm';

export default function useAdminTracks({ apiRequest }) {
  const [trackStats, setTrackStats] = useState(null);
  const [trackSessions, setTrackSessions] = useState([]);
  const [trackSettings, setTrackSettings] = useState({
    track_retention_days: 30,
    auto_cleanup_enabled: true,
    max_track_points_per_session: 10000,
    track_compression_enabled: true,
    track_export_formats: 'gpx,kml,json,csv',
    realtime_track_offline_grace_minutes: 30,
    member_temp_offline_minutes: 5,
    member_online_minutes: 5,
    member_offline_minutes: 15,
    member_marker_speed_auto: true
  });
  const [trackSettingsLoading, setTrackSettingsLoading] = useState(false);
  const [trackSettingsMsg, setTrackSettingsMsg] = useState('');

  const loadTrackSettings = async () => {
    try {
      console.log('🔄 开始加载轨迹设置...');
      const data = await apiRequest('/api/track/settings');
      console.log('📋 获取到的轨迹设置数据:', data);
      
      if (data.success) {
        // 确保数据类型正确
        const settings = {
          track_retention_days: parseInt(data.data.track_retention_days) || 30,
          auto_cleanup_enabled: data.data.auto_cleanup_enabled === true || data.data.auto_cleanup_enabled === 'true',
          max_track_points_per_session: parseInt(data.data.max_track_points_per_session) || 10000,
          track_compression_enabled: data.data.track_compression_enabled === true || data.data.track_compression_enabled === 'true',
          track_export_formats: data.data.track_export_formats || 'gpx,kml,json,csv',
          realtime_track_offline_grace_minutes: parseInt(data.data.realtime_track_offline_grace_minutes, 10) || 30,
          member_temp_offline_minutes: parseInt(
            data.data.member_temp_offline_minutes != null
              ? data.data.member_temp_offline_minutes
              : data.data.member_online_minutes,
            10
          ) || 5,
          member_online_minutes: parseInt(
            data.data.member_temp_offline_minutes != null
              ? data.data.member_temp_offline_minutes
              : data.data.member_online_minutes,
            10
          ) || 5,
          member_offline_minutes: parseInt(data.data.member_offline_minutes, 10) || 15,
          member_marker_speed_auto: data.data.member_marker_speed_auto !== false
            && data.data.member_marker_speed_auto !== 'false'
        };
        
        console.log('✅ 设置轨迹设置状态:', settings);
        setTrackSettings(settings);
      } else {
        console.error('❌ 加载轨迹设置失败:', data.message);
      }
    } catch (error) {
      console.error('❌ 加载轨迹设置异常:', error);
    }
  };

  // 保存轨迹设置
  const saveTrackSettings = async () => {
    setTrackSettingsLoading(true);
    setTrackSettingsMsg('');
    try {
      console.log('💾 开始保存轨迹设置:', trackSettings);
      
      const data = await apiRequest('/api/track/settings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(trackSettings)
      });

      console.log('📋 保存轨迹设置响应:', data);

      if (data.success) {
        setTrackSettingsMsg('轨迹设置保存成功');
        console.log('✅ 轨迹设置保存成功');
      } else {
        setTrackSettingsMsg(data.message || '保存失败');
        console.error('❌ 轨迹设置保存失败:', data.message);
      }
    } catch (error) {
      console.error('❌ 保存轨迹设置异常:', error);
      setTrackSettingsMsg('保存轨迹设置失败');
    } finally {
      setTrackSettingsLoading(false);
    }
  };

  // 加载轨迹统计信息
  const loadTrackStats = async () => {
    try {
      const data = await apiRequest('/api/track/stats');
      if (data.success) {
        setTrackStats(data.data);
      }
    } catch (error) {
      console.error('加载轨迹统计失败:', error);
    }
  };

  // 加载轨迹会话列表
  const loadTrackSessions = async () => {
    try {
      const data = await apiRequest('/api/track/sessions?limit=20');
      if (data.success) {
        setTrackSessions(data.data.sessions || []);
      }
    } catch (error) {
      console.error('加载轨迹会话失败:', error);
    }
  };

  const cleanupTrackData = async () => {
    let confirm_text;
    try {
      confirm_text = await confirmDangerousAction({
        title: '清理过期轨迹数据',
        content: '确定要清理过期的轨迹数据吗？此操作不可恢复！'
      });
    } catch {
      return;
    }

    try {
      const data = await apiRequest('/api/track/cleanup', {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ confirm_text })
      });

      if (data.success) {
        setTrackSettingsMsg(`清理完成，删除了 ${data.data.deleted_count} 条记录`);
        loadTrackStats();
        loadTrackSessions();
      } else {
        setTrackSettingsMsg(data.message || '清理失败');
      }
    } catch (error) {
      console.error('清理轨迹数据失败:', error);
      setTrackSettingsMsg('清理轨迹数据失败');
    }
  };


  return {
    trackStats, trackSessions, trackSettings, setTrackSettings, trackSettingsLoading, trackSettingsMsg,
    loadTrackSettings, saveTrackSettings, loadTrackStats, loadTrackSessions, cleanupTrackData
  };
}
